import type { ReactNode } from "react";
import {
  STATUS_FILLED_BADGE,
  STATUS_OUTLINE_BADGE,
  type StatusTone,
} from "@/components/ui/statusTone";

interface BadgeProps {
  tone: StatusTone;
  /**
   * `filled` carries its own pale background and is for a badge on plain surface; `outline` is for
   * one sitting inside a card header, where a second background reads as a second box.
   */
  variant?: "filled" | "outline";
  children: ReactNode;
}

/**
 * A status pill.
 *
 * The pods list and the pod detail screen each had their own, with different class names for the
 * same four states and the same colours written once as palette names and once as semantic ones.
 */
export function Badge({ tone, variant = "filled", children }: BadgeProps) {
  const palette = variant === "filled" ? STATUS_FILLED_BADGE[tone] : STATUS_OUTLINE_BADGE[tone];
  return (
    <span
      className={`shrink-0 whitespace-nowrap rounded-full border px-3 py-0.5 text-xs font-semibold ${palette}`}
    >
      {children}
    </span>
  );
}
